import { routeConfig } from "src/Routes/RouteConfig";

import { matchPath, useLocation } from "react-router-dom";

// Sort routes by length (longer paths first for more specific matching)
const sortedRoutes = [...routeConfig].sort(
  (a, b) => b.path.length - a.path.length
);

const useCurrentRouteConfig = () => {
  const location = useLocation();

  const currentRoute = sortedRoutes.find((route) =>
    matchPath({ path: route.path, end: false }, location.pathname)
  );

  return currentRoute;
};

export default useCurrentRouteConfig;
